import { papi } from "../../../lib/portalApi";

export const T = {
  deep: "#2A0E4F",
  violet: "#4C2380",
  violet2: "#6B34B8",
  gold: "#C9A45C",
  goldSoft: "#F3E6C8",
  green: "#2E7D4F",
  greenBg: "#E7F5EC",
  rose: "#FBEAF3",
  roseInk: "#B0407A",
  lavender: "#F4EEFC",
  line: "#ECE4F5",
  muted: "#6F6585",
};

// Ativo OFICIAL da Mini Cris: basta colocar o arquivo em frontend/public/cliente-icons/mini-cris.png.
// Ausente, corrompido ou com falha de carga => volta automaticamente para o simbolo dourado da marca.
export const MINI_CRIS_SRC = "/cliente-icons/mini-cris.png";

export const reduceMotion = () =>
  typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

// Evento de uso (sem valores financeiros). Falha silenciosa: nunca bloqueia a tela.
export const track = (type, ref) => { papi.post("/portal/events", { type, ref }).catch(() => {}); };

export const STATE = {
  available: { label: "Disponível", fg: "#2E7D4F", bg: "#E7F5EC" },
  review: { label: "Sujeito à análise", fg: "#7A4FC0", bg: "#EFE6FA" },
  building: { label: "Em construção", fg: "#A86200", bg: "#FFF3E0" },
  unavailable: { label: "Indisponível no momento", fg: "#6F6585", bg: "#EFEDF3" },
};
